﻿import React from 'react';
import ReactDOM from 'react-dom';
import { parseDate } from '../../../../Resources/Scripts/_Shared/parseDate';
import Moment from 'moment';
import 'custom-event-polyfill';
import { extendMoment } from 'moment-range';
const moment = extendMoment(Moment);

import controller from '../../../../Resources/Scripts/_Shared/controller';
import { DateSelection } from '../../../../Resources/Scripts/_Shared/form-date'

function myAimoParkInvoicesFilter(context) {
  const filtersDisabled = context.dataset.disabled && context.dataset.disabled === 'true';

  const freeTextInput = context.querySelector(".myaimoparkinvoicespage__filter--text input");
  const startDateInput = context.querySelector(".myaimoparkinvoicespage__filter--startdate input");
  const endDateInput = context.querySelector(".myaimoparkinvoicespage__filter--enddate input");
  const listItemsWrapper = context.querySelector(".myaimoparkinvoicespage__list");
  const listItemsWrapperClone = listItemsWrapper.cloneNode(true);
  const changeEvent = new CustomEvent('change');

  function init() {
    if (!filtersDisabled) {
      startDateInput.addEventListener('change', filter);
      endDateInput.addEventListener('change', filter);
      freeTextInput.addEventListener('keyup', debounce(filter, 300));
      addCustomDatePicker(startDateInput);
      addCustomDatePicker(endDateInput);
    }
  }

  async function filter(eventType) {
    //if (eventType === 'sort' && currentSortOrder === sortSelect.value) {
    //  ascendingOrder = !ascendingOrder;
    //}
    //else {
    //  currentSortOrder = sortSelect.value;
    //  if (currentSortOrder === 'valid-from' || currentSortOrder === 'valid-to') ascendingOrder = false;
    //  else ascendingOrder = true;
    //}
    const startDate = startDateInput.value.length === 0 ? null : parseDate(startDateInput.value);
    const endDate = endDateInput.value.length === 0 ? null : parseDate(endDateInput.value);
    const dateRange = moment.range(startDate, endDate);

    const listItemsToSearch = listItemsWrapperClone.cloneNode(true);
    const listItemsContainingValue = listItemsToSearch.querySelectorAll('li');

    listItemsWrapper.innerHTML = '';
    const newItemList = [];

    listItemsContainingValue.forEach((item, index) => {
      if (freeTextInput.value.length === 0 && !startDate && !endDate) {
        //listItemsWrapper.appendChild(item);
        newItemList.push({ element: item })
        return;
      }

      const searchableContentText = item.dataset.invoice.toUpperCase() + item.dataset.amount?.toUpperCase();
      const itemDate = item.dataset.date && parseDate(item.dataset.date);

      const textQuery = freeTextInput.value.toUpperCase();

      if (searchableContentText.indexOf(textQuery) !== -1 && (!startDate || !itemDate || dateRange.contains(itemDate)) && (!endDate || !itemDate || dateRange.contains(itemDate))) {
        //listItemsWrapper.appendChild(item);
        newItemList.push({ element: item });
      }
    });

    sortAndAddElementsToContainer(newItemList, listItemsWrapper)
    //countLabel.innerHTML = listItemsWrapper.childElementCount;

    listItemsWrapper.setAttribute('data-items', 10);
    freeTextInput.removeAttribute('aria-busy');
  }

  //function getSortValue(element) {
  //  if (currentSortOrder === 'valid-from') {
  //    return parseDate(element.dataset.startdate).valueOf();
  //  }
  //  else if (currentSortOrder === 'valid-to') {
  //    return element.dataset.enddate ? parseDate(element.dataset.enddate).valueOf() : parseDate(element.dataset.startdate).valueOf();
  //  }
  //  else if (currentSortOrder === 'id-number') {
  //    return parseInt(element.querySelector('.left .number').innerText, 10);
  //  }
  //  else if (currentSortOrder === 'place') {
  //    return element.querySelector('.left .zone').innerText;
  //  }
  //  else {
  //    return '';
  //  }
  //}

  function sortAndAddElementsToContainer(arr, container) {
    let sortedList = sortArray(arr);
    //if (currentSortOrder === 'valid-to' && arr.some(item => item.noEnddate)) {
    //  const sortedListSortvalue = sortArray(sortedList.filter(item => !item.noEnddate));
    //  const sortedListNoEnddateSortvalue = sortArray(sortedList.filter(item => item.noEnddate));
    //  sortedList = ascendingOrder ? [...sortedListNoEnddateSortvalue, ...sortedListSortvalue] : [...sortedListSortvalue, ...sortedListNoEnddateSortvalue];
    //}
    for (var i = 0; i < sortedList.length; i++) {
      container.appendChild(sortedList[i].element);
    }
  }
  function sortArray(arr) {
    return arr.sort((a, b) => {
      //if (ascendingOrder)
      //  return a.sortvalue > b.sortvalue ? 1 : -1;

      return a.sortvalue > b.sortvalue ? -1 : 1;
    });
  }

  function addCustomDatePicker(existingPicker) {
    existingPicker.classList.add('hide');

    const appContainer = document.createElement('DIV');
    appContainer.classList.add('Form__DatePickerWrapper');
    insertAfter(appContainer, existingPicker);

    ReactDOM.render(<DateSelection existingPicker={existingPicker} locale={document.querySelector('html').getAttribute('country')} placeholder={existingPicker.placeholder} onChangeEvent={() => { existingPicker.dispatchEvent(changeEvent); }} showAllDates={true} />, appContainer);

    setTimeout(function() {
      const startDateVisibleInput = context.querySelector(".myaimoparkinvoicespage__filter--startdate .DayPickerInput input");
      startDateVisibleInput.addEventListener('keyup', function () { checkIfEmpty("startdate") });
      const endDateVisibleInput = context.querySelector(".myaimoparkinvoicespage__filter--enddate .DayPickerInput input");
      endDateVisibleInput.addEventListener('keyup', function () { checkIfEmpty("enddate") });
    }, 500);
  }

  function checkIfEmpty(date) {
    const startDateVisibleInput = document.querySelector(".myaimoparkinvoicespage__filter--startdate .DayPickerInput input").value;
    const endDateVisibleInput = document.querySelector(".myaimoparkinvoicespage__filter--enddate .DayPickerInput input").value;
    if ((date === "startdate" && startDateVisibleInput.length === 0) || (date === "enddate" && endDateVisibleInput.length === 0)) filter();
  };

  function insertAfter(newNode, referenceNode) {
    referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
  }

  function debounce(func, wait, immediate) {
    var timeout;
    return function() {
      if (freeTextInput.value.length > 0) freeTextInput.setAttribute('aria-busy', 'true');

      var context = this, args = arguments;
      var later = function() {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  };

  return {
    init
  };
}

controller.add('my-aimo-park-invoices-filter', myAimoParkInvoicesFilter);